import { getArnPayload } from "../../components/Kpi/FleetData_";
import { axInstBasic } from "../../components/Service/Service";
import axios from "axios";

// export const fetchCustomData = async (arn) => {
//   try {
//     const res = await axInstCust.get(arn);
//     return res.data;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

//Get Token
export const fetchToken = async () => {
  // const data1 = new URLSearchParams({
  //   client_id: process.env.REACT_APP_CLIENT_ID_PVIN,
  //   client_secret: process.env.REACT_APP_CLIENT_SECRET_PVIN,
  //   grant_type: process.env.REACT_APP_GRANT_TYPE,
  //   username: process.env.REACT_APP_USERNAME,
  //   password: process.env.REACT_APP_PASSWORD,
  // });
  const data = new URLSearchParams({
    client_id: "rage",
    client_secret: "95jVKIJvqGUQJGJZP76bajVToK7xa1cI",
    grant_type: "password",
    username: "rage-service",
    password: process.env.REACT_APP_PASSWORD,
  });

  try {
    const res = await axios.post(
      "https://sso.tatamotors.com/auth/realms/Service/protocol/openid-connect/token",
      data.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(
      "Error fetching token:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getCustomerData = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getCustData`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};
